import { CapitalizeFirstLetter } from '@cdab/headless-components'
import type { TdsInlineTabsCustomEvent } from '@scania/tegel'
import { TdsInlineTab, TdsInlineTabs } from '@scania/tegel-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'
import type { AdminTranslationsTabsProps } from './admin-translation-tabs.types'

export function AdminTranslationsTabs({ links }: AdminTranslationsTabsProps) {
  const { t } = useTranslation('common')
  const location = useLocation()
  const navigate = useNavigate()
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)

  const tabRoutes = [
    links.pledges,
    links.auditPoints,
    links.auditPurposes,
    links.checkPoints,
    links.pledgePerspectives
  ]

  useEffect(() => {
    const currentIndex = tabRoutes.findIndex(
      route => location.pathname.includes(route) || location.pathname === route
    )
    if (currentIndex !== -1) {
      setSelectedTabIndex(currentIndex)
    }
  }, [location.pathname])

  const handleTabChange = (
    e: TdsInlineTabsCustomEvent<{
      selectedTabIndex: number
    }>
  ) => {
    const newIndex = e.detail.selectedTabIndex
    setSelectedTabIndex(newIndex)
    navigate(tabRoutes[newIndex])
  }

  return (
    <TdsInlineTabs
      modeVariant='primary'
      selectedIndex={selectedTabIndex}
      onTdsChange={handleTabChange}
    >
      <TdsInlineTab>
        <button>
          <CapitalizeFirstLetter>{t('pledges')}</CapitalizeFirstLetter>
        </button>
      </TdsInlineTab>
      <TdsInlineTab>
        <button>
          <CapitalizeFirstLetter>{t('audit-points')}</CapitalizeFirstLetter>
        </button>
      </TdsInlineTab>
      <TdsInlineTab>
        <button>
          <CapitalizeFirstLetter>{t('audit-purposes')}</CapitalizeFirstLetter>
        </button>
      </TdsInlineTab>
      <TdsInlineTab>
        <button>
          <CapitalizeFirstLetter>{t('checkpoints')}</CapitalizeFirstLetter>
        </button>
      </TdsInlineTab>
      <TdsInlineTab>
        <button>
          <CapitalizeFirstLetter>
            {t('pledge-perspectives')}
          </CapitalizeFirstLetter>
        </button>
      </TdsInlineTab>
    </TdsInlineTabs>
  )
}
